import fontWeights from './fontWeights';

const typography: TypographyProps = {
  t1: {
    'font-family': '"Arial", "Verdana", sans-serif',
    'font-size': { zero: 28, large: 48 },
    'line-height': { zero: '1.4', large: '1.6' },
    'text-transform': 'uppercase',
    'letter-spacing': '0.03em',
    'font-weight': fontWeights.bold,
    margin: 0,
  },
  t2: {
    'font-family': '"Arial", "Verdana", sans-serif',
    'font-size': 28,
    'line-height': '1.4',
    'text-transform': 'uppercase',
    'letter-spacing': '0.03em',
    'font-weight': fontWeights.bold,
    margin: 0,
  },
  h1: {
    'font-size': { zero: 28, large: 40 },
    'line-height': '1.4',
    'font-weight': fontWeights.medium,
    margin: 0,
  },
  h2: {
    'font-size': { zero: 24, large: 32 },
    'line-height': { zero: '1.1', large: '1.25' },
    'font-weight': fontWeights.medium,
    margin: 0,
  },
  h3: {
    'font-size': 24,
    'line-height': '1.4',
    'font-weight': fontWeights.medium,
    margin: 0,
  },
  h4: {
    'font-size': { zero: 16, medium: 18, large: 20 },
    'line-height': { zero: '1.42', medium: '1.6' },
    'letter-spacing': '0.05rem',
    'font-weight': fontWeights.medium,
    margin: 0,
  },
  h5: {
    'font-size': { zero: 16, medium: 18 },
    'line-height': { zero: '1.42', medium: '1.6' },
    'letter-spacing': '0.05rem',
    'font-weight': fontWeights.medium,
    margin: 0,
  },
  h6: {
    'font-size': { zero: 14 },
    'line-height': { zero: '1.42', medium: '1.5' },
    'letter-spacing': '0.05rem',
    'font-weight': fontWeights.medium,
    margin: 0,
  },
  p1: {
    'font-size': { zero: 16, medium: 18, large: 20 },
    'line-height': { zero: '1.5', large: '1.6' },
    margin: 0,
  },
  p2: {
    'font-size': { zero: 16, large: 18 },
    'line-height': '1.9',
    margin: 0,
  },
  p3: {
    'font-size': 16,
    'line-height': '1.5',
    margin: 0,
  },
  p4: {
    'font-size': 14,
    'line-height': '1.5',
    'font-weight': fontWeights.light,
    margin: 0,
  },
  l1: {
    'font-size': 12,
    'line-height': '1.4',
    margin: 0,
  },
  lead1: {
    'font-size': { zero: 20, large: 24 },
    'line-height': { zero: '1.5', large: '1.6' },
    margin: 0,
  },
};

export interface TypographyProps {
  [key: string]: object;
}

export default typography;
